module.exports = __webpack_public_path__ + "img/plant.1647c08b.svg";